import React from 'react'
import ContentBoxHeader from '../../../layout/component/ContentBoxHeader'
import EscalationIcon from '../../../form/component/EscalationIcon'
import VipIcon from '../../../form/component/VipIcon'
import ContentBoxWithoutHeader from '../../../layout/component/ContentBoxWithoutHeader'
import ContentBoxBody from '../../../layout/component/ContentBoxBody'
import CustomerInfo from './CustomerInfo'
import CustomerToolbar from './CustomerToolbar'
import CustomerTabHeader from './CustomerTabHeader'
import CustomerFeedback from './CustomerFeedback'

const getDeletedInfo = (customer) => {
    if (customer.deleted && customer.firstName !== 'Deleted') {
        const email = customer.email
        const emailSplit = email.split('deleted')
        const deleteTime = emailSplit[1].split('@sunshinesmile.de')

        return '(non-medical data deleted ' + deleteTime[0] + ')'
    }

    return ''
}

const CustomerHead = (props) => {
    const { customer } = props
    const deletedInfo = getDeletedInfo(customer)

    return (
        <ContentBoxWithoutHeader>
            <ContentBoxHeader>
                <h1>
                    <EscalationIcon inEscalation={customer.inEscalation}/>
                    <VipIcon
                        onClick={() => {

                        }}
                        active={customer.vip}/>&#160;
                    {'Customer ' + customer.firstName + ' ' + customer.lastName}&#160;
                    <span className="customer-info-important">
                        {deletedInfo}&#160;
                    </span>
                    <br/>
                </h1>
            </ContentBoxHeader>

            <ContentBoxBody>

                <CustomerToolbar {...props}/>

                <CustomerFeedback feedbackList={customer.feedbackList}/>

                <CustomerInfo {...props}/>

                <CustomerTabHeader {...props}/>

            </ContentBoxBody>

        </ContentBoxWithoutHeader>
    )
}

export default CustomerHead



// WEBPACK FOOTER //
// ./src/modules/customer/component/detail/CustomerHead.js